import { Tooltip, Typography, styled } from '@mui/material'
import { memo } from 'react'
import { colorPalette } from '../../../../style/colorPalette'

type Props = {
  path?: string
  parentDisplayName?: string
}

export const ProjectPlanPath = memo(({ path, parentDisplayName }: Props) => {
  return (
    <Tooltip title={path ?? ''} placement="top">
      <StyledContainer>
        <StyledPrefix>... /</StyledPrefix>
        <Typography
          component="div"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {parentDisplayName}
        </Typography>
        <StyledSuffix>/</StyledSuffix>
      </StyledContainer>
    </Tooltip>
  )
})

const StyledContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  maxWidth: '100%',
  width: 'fit-content',
  fontWeight: '400',
  color: colorPalette.monotone[4],
})

const StyledPrefix = styled('p')({
  margin: '0 5px 0 0',
  flexShrink: 0,
})

const StyledSuffix = styled('p')({
  margin: '0 0 0 5px',
  flexShrink: 0,
})
